var render = function render(){
  var _vm$global$profile, _vm$order$skin, _vm$order$skin2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.reloadOrderStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.replaceDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }, [_vm._v(" Sorry, something went wrong trying to save your changes. Please try again later. ")]), _vm.showGiphy ? _c('tenor-dialog', {
    on: {
      "select": function (v) {
        return _vm.quick.media.push({
          w: parseInt(v.w),
          h: parseInt(v.h),
          url: v.url,
          gif: true
        });
      }
    },
    model: {
      value: _vm.showGiphy,
      callback: function ($$v) {
        _vm.showGiphy = $$v;
      },
      expression: "showGiphy"
    }
  }) : _vm._e(), _vm.showGiftcardPayment ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.showGiftcardPayment.resolve(false);
      }
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column"
  }, [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.showGiftcardPayment.resolve(false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Add gift card")]), _c('payment', {
    staticClass: "pb-4 mx-auto",
    staticStyle: {
      "min-height": "414px"
    },
    attrs: {
      "metadata": _vm.showGiftcardPayment.metadata
    },
    on: {
      "complete": function ($event) {
        return _vm.showGiftcardPayment.resolve(true);
      }
    }
  })], 1)], 1) : _vm._e(), _vm.showGiftcard ? _c('giftcard-dialog', {
    attrs: {
      "order-id": _vm.orderId,
      "order": _vm.order,
      "is-completed": false,
      "max-value": _vm.maxAddGiftcardValue
    },
    on: {
      "select": function (v) {
        return _vm.quick.media.push({
          w: 300,
          h: 190,
          url: v.product_img,
          giftcard: v
        });
      }
    },
    model: {
      value: _vm.showGiftcard,
      callback: function ($$v) {
        _vm.showGiftcard = $$v;
      },
      expression: "showGiftcard"
    }
  }) : _vm._e(), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "image",
    attrs: {
      "type": "file",
      "accept": "image/*,image/heic"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _vm.showPreview ? _c('dialog-scroll-lock', {
    attrs: {
      "fullscreen": "",
      "transition": false,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          hash: undefined
        }));
      }
    }
  }, [_vm.order ? _c('card-open', {
    staticClass: "absolute-fill",
    attrs: {
      "preview": _vm.order,
      "block": true
    },
    on: {
      "close": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          hash: undefined
        }));
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c('group-video-status-dialog', {
    attrs: {
      "status": _vm.groupVideoStatus
    },
    on: {
      "continue": function ($event) {
        _vm.groupVideoStatus = null;
        !_vm.isStandaloneGroupVideo && _vm.loadGroupVideo();
      },
      "close": function () {
        if (_vm.isStandaloneGroupVideo) _vm.tryClose();else _vm.groupVideoStatus = null;
      }
    }
  }, [!_vm.isStandaloneGroupVideo ? _c('div', {
    staticClass: "pt-6"
  }, [_vm._v(" Click the "), _c('v-btn', {
    staticClass: "mx-1 px-2",
    staticStyle: {
      "vertical-align": "inherit"
    },
    attrs: {
      "rounded": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.groupVideoStatus = null;
        _vm.showInfo = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelp)
    }
  }), _vm._v(" Help")], 1), _vm._v(" button at the top of the screen, or find the video on page " + _vm._s(_vm.groupVideoPageI + 1) + " of the card to reopen the project. ")], 1) : _vm._e()]), _vm.showInfo && !_vm.canSign ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showInfo,
      callback: function ($$v) {
        _vm.showInfo = $$v;
      },
      expression: "showInfo"
    }
  }, [_c('v-card', {
    staticClass: "warning",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showInfo = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLock)
    }
  }), _vm.order.type == 'GROUP' ? _c('div', [_vm._v("This card is locked")]) : _c('div', [_vm._v("This is not a group card")])], 1), _vm.order.user_id == _vm.globalUserId ? _c('v-card-text', {
    staticClass: "white--text text-body-1"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": {
        name: _vm.order.state == 'PENDING' ? 'project' : 'account-orders',
        params: {
          orderId: _vm.orderId
        }
      }
    }
  }, [_vm._v("Manage this card from your account")])], 1) : _c('v-card-text', {
    staticClass: "white--text text-body-1"
  }, [_c('span', [_vm._v("Only the organizer can make changes.")]), _vm.order.type == 'GROUP' && _vm.order.lock != 'FORCE' ? _c('span', [_vm._v(" Please contact the organizer to unlock it.")]) : _vm._e()]), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.org_admin && _vm.global.profile.org_id == _vm.order.org_id ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-switch', {
    attrs: {
      "hide-details": "",
      "label": "Edit as owner"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "v-card__text pa-0"
        }, [_vm._v("Edit as owner "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$confirm({
                title: 'Edit as owner',
                msg: 'As an organization administrator, you can toggle this switch to make edits to the card as if you were the one who created it.',
                primary: 'Ok',
                buttons: ['Ok']
              });
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiHelpCircle)
          }
        })], 1)], 1)];
      },
      proxy: true
    }], null, false, 3803454229),
    model: {
      value: _vm.editAsOwner,
      callback: function ($$v) {
        _vm.editAsOwner = $$v;
      },
      expression: "editAsOwner"
    }
  })], 1)] : _vm._e()], 2)], 1) : _vm.showInfo ? _c('dialog-scroll-lock', {
    attrs: {
      "persistent": _vm.canSign && !_vm.myPageIndexes.length && !_vm.didCloseInfo,
      "width": _vm.showAddQuick ? 440 : 360
    },
    model: {
      value: _vm.showInfo,
      callback: function ($$v) {
        _vm.showInfo = $$v;
      },
      expression: "showInfo"
    }
  }, [_c('v-expand-transition', [_vm.showAddQuick ? _c('v-card', [_c('v-list', {
    key: "add-quick-back"
  }, [_c('v-list-item', {
    staticClass: "primary--text li-pop simple",
    on: {
      "click": function ($event) {
        _vm.showAddQuick = false;
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  }), _c('div', {
    staticClass: "pl-0"
  }, [_vm._v("Back")])], 1)], 1), _c('div', {
    staticClass: "px-6 pt-1 pb-5"
  }, [_c('div', {
    staticClass: "ma-n1",
    staticStyle: {
      "min-width": "calc(100vw - 88px)"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1 px-2 white--text",
    attrs: {
      "small": "",
      "color": "cyan",
      "disabled": _vm.quick.media.length >= 9 || _vm.quick.media.filter(function (x) {
        return x.gif;
      }).length >= 4
    },
    on: {
      "click": function ($event) {
        _vm.showGiphy = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiStickerEmoji)
    }
  }), _c('span', [_vm._v("Add GIF")])], 1), _c('v-btn', {
    staticClass: "ma-1 px-2 white--text",
    attrs: {
      "small": "",
      "color": "indigo",
      "disabled": _vm.quick.media.length >= 9 || _vm.quick.media.filter(function (x) {
        return x.upload;
      }).length >= 3
    },
    on: {
      "click": _vm.promptUpload
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImage)
    }
  }), _c('span', [_vm._v("Add picture")])], 1), _vm.maxAddGiftcardValue > 0 && (_vm.isOwner || !((_vm$order$skin = _vm.order.skin) !== null && _vm$order$skin !== void 0 && _vm$order$skin.disable_contributor_giftcards)) ? [_vm.giftcardBlobsEditable.length ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "width": "320",
      "max-width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-1 px-2 white--text",
          attrs: {
            "small": "",
            "color": "green lighten-2",
            "disabled": _vm.quick.media.length >= 9 || !!_vm.quick.media.find(function (x) {
              return x.giftcard;
            })
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
          }
        }), _c('span', [_vm._v("Add gift card")]), _c('v-icon', {
          staticClass: "menu-down mr-n1",
          attrs: {
            "small": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1)];
      }
    }], null, false, 908705346)
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-subtitle', {
    staticClass: "text--label-active px-3 pt-1 pb-2"
  }, [_vm._v(" Add value to existing gift card ")]), _vm._l(_vm.giftcardBlobsEditable, function (g) {
    var _g$giftcard$claim_ids, _g$giftcard$claim_ids2;
    return _c('v-list-item', {
      key: 'add-quick-' + g.id,
      staticClass: "li-pop simple px-3",
      on: {
        "click": function ($event) {
          _vm.showGiftcardBlob = g;
        }
      }
    }, [_c('v-img', {
      staticClass: "v-card v-sheet mr-0",
      style: {
        opacity: (_g$giftcard$claim_ids = g.giftcard.claim_ids) !== null && _g$giftcard$claim_ids !== void 0 && _g$giftcard$claim_ids.length ? .5 : 1
      },
      attrs: {
        "width": "42",
        "min-width": "42",
        "max-width": "42",
        "aspect-ratio": 300 / 190,
        "src": g.giftcard.product_img
      }
    }), _c('div', {
      staticClass: "pl-0",
      class: {
        'grey--text text--lighten-1': (_g$giftcard$claim_ids2 = g.giftcard.claim_ids) === null || _g$giftcard$claim_ids2 === void 0 ? void 0 : _g$giftcard$claim_ids2.length
      },
      staticStyle: {
        "max-width": "calc(100% - 66px)"
      }
    }, [_c('div', {
      staticClass: "overline short",
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      },
      domProps: {
        "textContent": _vm._s(g.giftcard.product_name)
      }
    }), _c('div', {
      staticClass: "text--label-active",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('currency', {
      attrs: {
        "code": g.giftcard.cur
      }
    }), _vm._v(_vm._s(g.giftcard.amt) + " ")], 1)]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-list-item', {
    staticClass: "li-pop simple px-3 py-4",
    on: {
      "click": function ($event) {
        _vm.showGiftcard = true;
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "padding": "0 9px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('div', {
    staticClass: "px-0"
  }, [_vm._v("Add new gift card")]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 2)], 1) : _c('v-btn', {
    staticClass: "ma-1 px-2 white--text",
    attrs: {
      "small": "",
      "color": "green lighten-2",
      "disabled": !!_vm.quick.media.find(function (x) {
        return x.giftcard;
      })
    },
    on: {
      "click": function ($event) {
        _vm.showGiftcard = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('span', [_vm._v("Add gift card")])], 1)] : _vm._e()], 2), _c('div', {
    staticClass: "my-3 mx-n3",
    staticStyle: {
      "column-count": "3",
      "column-gap": "0"
    }
  }, _vm._l(_vm.quick.media, function (_ref2, i) {
    var url = _ref2.url,
      w = _ref2.w,
      h = _ref2.h,
      giftcard = _ref2.giftcard;
    return _c('div', {
      staticClass: "relative pa-3 mx-auto"
    }, [_c('v-card', [_c('img', {
      staticClass: "d-block fill-width",
      style: {
        'aspect-ratio': w / h
      },
      attrs: {
        "src": url
      }
    })]), _c('v-btn', {
      staticStyle: {
        "top": "0",
        "right": "0"
      },
      attrs: {
        "x-small": "",
        "fab": "",
        "absolute": ""
      },
      on: {
        "click": function ($event) {
          return _vm.quick.media.splice(i, 1);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiClose)
      }
    })], 1), giftcard ? _c('v-btn', {
      staticStyle: {
        "bottom": "0",
        "left": "0"
      },
      attrs: {
        "small": "",
        "color": "green lighten-2",
        "absolute": "",
        "rounded": "",
        "dark": ""
      }
    }, [_c('currency', {
      attrs: {
        "code": giftcard.cur
      }
    }), _vm._v(" " + _vm._s(giftcard.amt) + " "), (_vm.order.n_giftcard_recipients || 1) > 1 ? _c('span', {
      staticClass: "ml-1 grey--text text--lighten-2"
    }, [_vm._v("×" + _vm._s(_vm.order.n_giftcard_recipients))]) : _vm._e()], 1) : _vm._e()], 1);
  }), 0), _c('v-form', {
    ref: "quick-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-textarea', {
    staticClass: "mt-3 inline-error white",
    attrs: {
      "outlined": "",
      "dense": "",
      "auto-grow": "",
      "rows": "5",
      "label": "Message",
      "persistent-placeholder": "",
      "rules": [function (v) {
        return !!v || 'Required';
      }]
    },
    model: {
      value: _vm.quick.msg,
      callback: function ($$v) {
        _vm.$set(_vm.quick, "msg", $$v);
      },
      expression: "quick.msg"
    }
  }), _c('ul', {
    staticClass: "text--label-active mt-3 mb-3 ml-n2"
  }, [_c('li', [_vm._v("Don't forget to include your name")]), _c('li', [_vm._v("You can still edit your message later, including the font, color, and layout")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.submitQuick
    }
  }, [_vm._v(" Submit "), _c('v-icon', {
    staticClass: "ml-1 mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)], 1)], 1)], 1) : _c('v-card', {
    staticClass: "pt-6"
  }, [!(_vm.canSign && !_vm.myPageIndexes.length && !_vm.didCloseInfo) ? _c('v-btn', {
    staticStyle: {
      "top": "12px",
      "right": "12px"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showInfo = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mx-auto relative",
    staticStyle: {
      "aspect-ratio": "7 / 5",
      "max-width": "200px"
    }
  }, [_c('envelope', {
    staticStyle: {
      "position": "absolute",
      "inset": "-20% 0 -20% 0"
    },
    attrs: {
      "skin": _vm.order.skin,
      "from": _vm.order.info.from,
      "to": _vm.to
    }
  })], 1), _c('v-card-title', {
    staticClass: "pt-6"
  }, [_vm._v("Sign this group card")]), _vm.order.msg ? _c('v-card-subtitle', {
    staticClass: "pb-3 font-italic",
    staticStyle: {
      "max-width": "360px"
    }
  }, [_vm._v(" " + _vm._s(_vm.order.msg) + " ")]) : _vm._e(), _c('v-list', {
    staticClass: "primary--text"
  }, [!_vm.myPageIndexes.length ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.showAddQuick = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMessageFlash)
    }
  }), _c('div', [_c('div', [_vm._v("Add a quick message")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("With automatic layout")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm._e(), _vm.maxAddGiftcardValue > 0 && (_vm.isOwner || !((_vm$order$skin2 = _vm.order.skin) !== null && _vm$order$skin2 !== void 0 && _vm$order$skin2.disable_contributor_giftcards)) ? [_vm.giftcardBlobsEditable.length == 1 ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.showGiftcardBlob = _vm.giftcardBlobsEditable[0];
      }
    }
  }, [_c('div', {
    staticClass: "v-icon v-icon-container"
  }, [_c('v-img', {
    staticClass: "v-card v-sheet",
    attrs: {
      "width": "42",
      "min-width": "42",
      "max-width": "42",
      "aspect-ratio": 300 / 190,
      "src": _vm.giftcardBlobsEditable[0].giftcard.product_img
    }
  })], 1), _c('div', [_c('div', [_vm._v("Add to group gift card")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit",
      "text-transform": "uppercase",
      "letter-spacing": "0.1667em !important"
    },
    domProps: {
      "textContent": _vm._s(_vm.giftcardBlobsEditable[0].giftcard.product_name)
    }
  })]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm.giftcardBlobsEditable.length ? _c('v-menu', {
    attrs: {
      "offset-x": "",
      "width": "320",
      "max-width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-list-item', _vm._g(_vm._b({
          staticClass: "li-pop simple pr-5"
        }, 'v-list-item', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
          }
        }), _c('div', [_c('div', [_vm._v("Add to group gift cards")]), _c('div', {
          staticClass: "text--label-active",
          staticStyle: {
            "color": "inherit"
          }
        }, [_vm._v(_vm._s(_vm.giftcardBlobsEditable.length) + " gift cards")])]), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)];
      }
    }], null, false, 3792116879)
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, [_vm._l(_vm.giftcardBlobsEditable, function (g) {
    var _g$giftcard$claim_ids3, _g$giftcard$claim_ids4;
    return _c('v-list-item', {
      key: 'add-top-level-' + g.id,
      staticClass: "li-pop simple px-3",
      on: {
        "click": function ($event) {
          _vm.showGiftcardBlob = g;
        }
      }
    }, [_c('v-img', {
      staticClass: "v-card v-sheet mr-0",
      style: {
        opacity: (_g$giftcard$claim_ids3 = g.giftcard.claim_ids) !== null && _g$giftcard$claim_ids3 !== void 0 && _g$giftcard$claim_ids3.length ? .5 : 1
      },
      attrs: {
        "width": "42",
        "min-width": "42",
        "max-width": "42",
        "aspect-ratio": 300 / 190,
        "src": g.giftcard.product_img
      }
    }), _c('div', {
      staticClass: "pl-0",
      class: {
        'grey--text text--lighten-1': (_g$giftcard$claim_ids4 = g.giftcard.claim_ids) === null || _g$giftcard$claim_ids4 === void 0 ? void 0 : _g$giftcard$claim_ids4.length
      },
      staticStyle: {
        "max-width": "calc(100% - 66px)"
      }
    }, [_c('div', {
      staticClass: "overline short",
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      },
      domProps: {
        "textContent": _vm._s(g.giftcard.product_name)
      }
    }), _c('div', {
      staticClass: "text--label-active",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('currency', {
      attrs: {
        "code": g.giftcard.cur
      }
    }), _vm._v(_vm._s(g.giftcard.amt) + " ")], 1)]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-list-item', {
    staticClass: "li-pop simple px-3 py-4",
    on: {
      "click": function ($event) {
        _vm.autoSwipeToNewPage();
        _vm.$refs['card-editor'].showGiftcard = true;
        _vm.showInfo = false;
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "padding": "0 9px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('div', {
    staticClass: "px-0"
  }, [_vm._v("Add new gift card")]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 2)], 1) : _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.autoSwipeToNewPage();
        _vm.$refs['card-editor'].showGiftcard = true;
        _vm.showInfo = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('div', [_vm._v("Add gift card")]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)] : _vm._e(), _vm.groupVideoBlob ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": _vm.loadGroupVideo
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _c('div', [_c('div', [_vm._v("Add to group video")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("On page " + _vm._s(_vm.groupVideoPageI + 1))])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm._e(), !_vm.myPageIndexes.length ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.autoSwipeToNewPage();
        _vm.showInfo = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _c('div', [_c('div', [_vm._v("Sign the card directly")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("For complete editorial control")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm.myPageIndexes.length == 1 ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.showInfo = false;
        _vm.$refs['card-editor'].swipe(_vm.myPageIndexes[0] - _vm.$refs['card-editor'].selectedPageI);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMagnify)
    }
  }), _c('div', [_c('div', [_vm._v("Show your message")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("You already added to this card")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _c('v-menu', {
    attrs: {
      "offset-x": "",
      "width": "200",
      "max-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('v-list-item', _vm._g(_vm._b({
          staticClass: "li-pop simple pr-5"
        }, 'v-list-item', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMagnify)
          }
        }), _c('div', [_c('div', [_vm._v("Show your messages")]), _c('div', {
          staticClass: "text--label-active",
          staticStyle: {
            "color": "inherit"
          }
        }, [_vm._v("You already added to this card")])]), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.myPageIndexes, function (i) {
    return _c('v-list-item', {
      key: 'signed-page-' + i,
      staticClass: "li-pop simple px-3",
      on: {
        "click": function ($event) {
          _vm.showInfo = false;
          _vm.$refs['card-editor'].swipe(i - _vm.$refs['card-editor'].selectedPageI);
        }
      }
    }, [_c('card-preview', {
      staticClass: "inline-page-preview v-card v-sheet",
      staticStyle: {
        "max-width": "42px"
      },
      attrs: {
        "mode": _vm.canSign ? 'edit' : 'view',
        "card": Object.assign({}, _vm.order, {
          pages: [Object.assign({}, _vm.order.pages[i], {
            blobs: _vm.order.pages[i].blobs.slice().map(function (x) {
              return Object.assign({}, x, {
                opacity: x.user_id == _vm.userId ? 1 : .5
              });
            })
          })]
        }),
        "width": 42
      }
    }), _c('div', [_vm._v("Page " + _vm._s(i + 1))]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), 1)], 1)], 2), _c('v-divider', {
    staticClass: "mt-6"
  }), _c('div', {
    staticClass: "px-5"
  }, [_c('v-switch', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "color": "grey darken-2",
      "label": "Show button labels"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "v-card__text pa-0 pl-2"
        }, [_vm._v("Show button labels")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.global.showHelp,
      callback: function ($$v) {
        _vm.$set(_vm.global, "showHelp", $$v);
      },
      expression: "global.showHelp"
    }
  })], 1), _c('v-list', {
    staticClass: "text-body-2",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [!_vm.order.skin.hide_account ? _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    }
  }, [_vm.isSignedIn ? [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccountCheck)
    }
  }), _c('div', [_c('div', [_vm._v("Signed in")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v(_vm._s(_vm.global.profile.email))])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLogout)
    }
  })] : [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccount)
    }
  }), _c('div', [_c('div', [_vm._v("Sign in")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("Sign in to revisit your changes later")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLogin)
    }
  })]], 2) : _vm._e(), _c('v-list-item', {
    staticClass: "li-pop simple pr-5",
    on: {
      "click": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          hash: '#preview'
        }));
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiEmailOpen)
    }
  }), _c('div', [_c('div', [_vm._v("Preview")]), _c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "color": "inherit"
    }
  }, [_vm._v("See what " + _vm._s(_vm.order.multiple_recipients ? 'a' : 'the') + " recipient will see")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('sign-in-dialog', {
    ref: "sign-in",
    attrs: {
      "allow-anonymous": !_vm.isStandaloneGroupVideo,
      "transition": false,
      "skin": _vm.order ? _vm.order.skin : {}
    },
    scopedSlots: _vm._u([_vm.isStandaloneGroupVideo ? {
      key: "title",
      fn: function () {
        return [_vm._v(" Sign in to add content ")];
      },
      proxy: true
    } : null, {
      key: "subtitle",
      fn: function () {
        return [_vm.isStandaloneGroupVideo ? [_vm._v("We use your email address (A) so we have a record of who added what content, and (B) so you can manage your content after it's been saved.")] : [_vm._v("Sign in with your email address so the organizer has a record of who contributed to the " + _vm._s(_vm.orderType) + " and so you can edit your content later")]];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _vm.showGiftcardBlob ? _c('giftcard-add-dialog', {
    attrs: {
      "order-id": _vm.orderId,
      "order": _vm.order,
      "blob": _vm.showGiftcardBlob,
      "locked": !_vm.canSign,
      "max-value": _vm.maxAddGiftcardValue
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }) : _vm._e(), _c('dialog-scroll-lock', {
    attrs: {
      "transition": "",
      "fullscreen": "",
      "content-class": "white overflow-x-hidden",
      "persistent": "",
      "no-click-animation": "",
      "value": true
    }
  }, [!_vm.isStandaloneGroupVideo && _vm.showGroupVideo && _vm.groupVideoBlob ? [_vm.order.lock ? _c('group-video-playback', {
    attrs: {
      "dialog": "",
      "mode": "open",
      "project-id": _vm.groupVideoBlob.group_video.project_id
    },
    on: {
      "slow-playback": _vm.onSlowPlayback
    },
    model: {
      value: _vm.showGroupVideo,
      callback: function ($$v) {
        _vm.showGroupVideo = $$v;
      },
      expression: "showGroupVideo"
    }
  }) : _c('group-video-editor', {
    attrs: {
      "project-id": _vm.groupVideoBlob.group_video.project_id,
      "order": _vm.order
    },
    on: {
      "input": function (value, status) {
        _vm.showInfo = false;
        _vm.groupVideoStatus = status;
      }
    },
    model: {
      value: _vm.showGroupVideo,
      callback: function ($$v) {
        _vm.showGroupVideo = $$v;
      },
      expression: "showGroupVideo"
    }
  })] : _vm._e(), _c('div', {
    staticClass: "fill-height overflow-hidden",
    staticStyle: {
      "min-height": "max(100%, calc(480px + 73px))"
    },
    style: {
      'background-color': _vm.order ? _vm.order.skin.page_background_color : null
    }
  }, [!_vm.global.profile || _vm.loadStatus.pending ? _c('div', {
    staticClass: "fill-height d-flex justify-center align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm.order ? [_c('card-background', {
    attrs: {
      "src": _vm.order.skin.page_background_img
    }
  }), _c('div', {
    staticClass: "header d-flex align-start pa-1"
  }, [_c('div', {
    staticClass: "flex-grow-0 fill-height relative"
  }, [_vm.order.skin.header_logo ? _c('img', {
    staticClass: "absolute",
    attrs: {
      "height": "100%",
      "src": _vm.order.skin.header_logo
    }
  }) : _c('img', {
    staticClass: "absolute",
    attrs: {
      "height": "100%",
      "src": "/ellacard-logo-filled-307x160.png",
      "alt": "Ellacard",
      "title": "Ellacard"
    }
  })]), _c('v-spacer'), _vm.viewAs ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "elevation": "5",
      "large": "",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.$refs['card-editor'].viewAs = null;
      }
    }
  }, [_c('v-icon', {
    staticClass: "ml-n1 mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathCardPages)
    }
  }), _vm._v(" View as book ")], 1) : _c('div', {
    staticClass: "ma-2 v-btn--is-elevated v-btn--fab btn-group btn-group-horizontal",
    staticStyle: {
      "border-radius": "28px",
      "z-index": "1"
    }
  }, [!_vm.isStandaloneGroupVideo ? _c('v-btn', {
    attrs: {
      "elevation": "0",
      "large": "",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showInfo = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "ml-n1 mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelp)
    }
  }), _vm._v(" Help ")], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "large": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.tryClose
    }
  }, [_c('div', {
    staticClass: "ml-n1 mr-1 relative"
  }, [_vm.dirty || _vm.saveStatus.pending ? _c('v-progress-circular', {
    attrs: {
      "size": "16",
      "width": "1",
      "indeterminate": ""
    }
  }) : _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCheck)
    }
  })], 1), _vm._v(" Done ")])], 1)], 1), _c('div', {
    staticClass: "body"
  }, [_vm.isStandaloneGroupVideo ? _c('div', {
    staticClass: "relative fill-height mx-auto px-md-3 pb-md-3",
    staticStyle: {
      "max-width": "1200px"
    }
  }, [_c('div', {
    staticClass: "relative fill-height"
  }, [_c('v-card', {
    staticClass: "absolute-fill",
    attrs: {
      "tile": ""
    }
  }, [_c('group-video-editor', {
    ref: "group-video-editor",
    staticClass: "fill-height",
    attrs: {
      "block": "",
      "project-id": _vm.groupVideoBlob.group_video.project_id,
      "order": _vm.order
    }
  })], 1)], 1)]) : _c('card-editor', {
    ref: "card-editor",
    attrs: {
      "order-id": _vm.orderId,
      "card": _vm.order,
      "is-owner": _vm.isOwner,
      "mode": _vm.canSign ? 'edit' : 'view',
      "has-group-video": !!_vm.groupVideoBlob,
      "max-giftcard-value": _vm.maxAddGiftcardValue,
      "allow-replace-design": _vm.order && _vm.order.allow_replace_design,
      "is-verified-recipient": _vm.order && _vm.order.verified_recipient,
      "show-help": _vm.global.showHelp
    },
    on: {
      "input": function ($event) {
        _vm.dirty = true;
      },
      "insert-blob": _vm.onInsertOrUpdate,
      "update-blob": _vm.onInsertOrUpdate,
      "update-layers": function (x) {
        return _vm.didUpdateLayersForPageIds.add(x);
      },
      "insert-page": function (pageId) {
        return _vm.addedPageIds.push(pageId);
      },
      "delete-blob": function (blob) {
        _vm.removedBlobIds.push(blob.id);
        _vm.enqueueSave(false);
      },
      "delete-page": function (page) {
        _vm.removedPageIds.push(page.id);
        _vm.enqueueSave(false);
      },
      "view-as": function (x) {
        return _vm.viewAs = x;
      },
      "click-giftcard": function (x) {
        return _vm.showGiftcardBlob = x;
      },
      "click-group-video": function ($event) {
        _vm.showGroupVideo = true;
      },
      "click-edit-form": function ($event) {
        return _vm.$router.push({
          name: 'account-orders',
          params: {
            orderId: _vm.orderId
          },
          hash: '#event'
        });
      },
      "page-group-video": function () {
        if (!_vm.didShowGroupVideo && !_vm.order.lock) _vm.showGroupVideo = true;
      },
      "replace-design": _vm.replaceDesign,
      "reload": _vm.reloadOrder,
      "save": function ($event) {
        return _vm.enqueueSave(true);
      }
    }
  })], 1)] : _vm.notFound && !_vm.isRedirecting ? _c('div', {
    staticClass: "d-flex flex-column justify-center align-center pa-4 fill-height"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Card not found")]), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "to": {
        name: 'start'
      }
    }
  }, [_vm._v("Home")]), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "to": {
        name: 'catalog'
      }
    }
  }, [_vm._v("Browse cards")]), _c('div', {
    staticClass: "mt-8 text-center"
  }, [_vm._v(" Think you're seeing this page in error? Please let us know!"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@ellacard.com"
    }
  }, [_vm._v("support@ellacard.com")])])], 1) : _vm._e()], 2)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }